module.exports = __webpack_public_path__ + "static/media/Radiant_Bookcover.a7003faf.jpg";